import request from '../../libs/request';

export default {
  sendContact: (body, siteId) => request(`api/v1/${siteId}/contato/whatsapp`).post({ body }),
};
